import { React, useState, useEffect } from 'react';
import '../style/header.scss';

import { Link } from "react-router-dom";

import logo from '../images/sqf-puzzles.png';
import menuIcon1 from '../images/svg/play-inactive.svg';
import menuIcon2 from '../images/svg/puzzle-inactive.svg';
import menuIcon3 from '../images/svg/analyse-inactive.svg';

const Header = () => {

	const [menuActive,setMenuActive] = useState(false);

	const toggleMenu = event => {
		setMenuActive(current => !current);
	};
  
	return (
		<div className="header">
			<div className="header-box posr">
				<Link to="/"><img src={logo} className="logo" alt="logo" /></Link>
				<div className="hide-on-desktop">
					<div className="hamburger-lines" onClick={toggleMenu}>
						<span className={'line line1' + (menuActive ? ' active' : '')}></span>
						<span className={'line line2' + (menuActive ? ' active' : '')}></span>
						<span className={'line line3' + (menuActive ? ' active' : '')}></span>
					</div>  
				</div>  
				<div className={'menu' + (menuActive ? ' active' : '')}>
    				<div className="menu-sub">
						<a className="menu-a" target="_blank" rel="noreferrer" href="https://live.squareoffnow.com/">Live Games</a>
						<a className="menu-a" target="_blank" rel="noreferrer" href="https://squareoffnow.com/apps/gifs">GIFS</a>
						<a className="menu-a" target="_blank" rel="noreferrer" href="https://squareoffnow.com/#productMinistore">Explore Products</a>
    					<a className="menu-a" target="_blank" rel="noreferrer" href="https://squareoffnow.com/contact-us">Contact Us</a>
						<a className="menu-a the-app" target="_blank" rel="noreferrer" href="https://squareoffnow.com/mobile-app">The App</a>
    				</div>
    			</div>
			</div>
		</div>
	);
	
  
}

export default Header;